import { render, staticRenderFns } from "./MessageThreadNavWidget.vue?vue&type=template&id=28f07812"
import script from "./MessageThreadNavWidget.vue?vue&type=script&lang=js"
export * from "./MessageThreadNavWidget.vue?vue&type=script&lang=js"
import style0 from "./MessageThreadNavWidget.vue?vue&type=style&index=0&id=28f07812&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports